import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getUserData } from "../utils/localStorage";
import StoreMenu from "./StoreMenu";
import { formatDate } from "../constants/DateUtil/DateUtil";
import ButtonLink from "../ButtonLink";

const StoreProfile = () => {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);

  const { brandProfileData,storeData } = getUserData();

  let formattedRegistrationDate = storeData.createdDate
    ? formatDate(storeData.createdDate)
    : "";

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                 
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold uppercase">
                Store Profile
              </p>
            </div>
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>
      <div>
        <div className="flex-1">
          <div
            className="flex-1  surface-0"
            style={{ "--surface-0": "#EAEFF5" }}
          >
            <div className="flex justify-content-between mx-4">
              <div className="py-1">
                <p className=" text-2xl  font-bold ">
                  Basic Info
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="flex-1 ">
          <div className="m-4 shadow-4">
            <div className="flex flex-1">
              <div
                className="flex-1 px-3 py-1"
                style={{
                  backgroundColor: "#F8FFEE",
                }}
              >
                <p
                  className="text-md font-normal capitalize"
                  style={{ color: "#75879B" }}
                >
                  Store Name :
                </p>
                <p className="text-lg font-medium capitalize">
                  {" "}
                  {storeData.storeName}
                </p>
              </div>
              <div
                className="flex-1 px-3 py-1"
                style={{
                  backgroundColor: "#E2F4F8",
                }}
              >
                <p
                  className="text-md font-normal capitalize"
                  style={{ color: "#75879B" }}
                >
                  Store Code :
                </p>
                <p className="text-lg font-medium capitalize">
                  {storeData.storeCode}
                </p>
              </div>
              <div
                className="flex-1 px-3 py-1"
                style={{
                  backgroundColor: "#F8FFEE",
                }}
              >
                <p
                  className="text-md font-normal capitalize"
                  style={{ color: "#75879B" }}
                >
                  Email :
                </p>
                <p className="text-lg font-medium capitalize">
                  {storeData.email}
                </p>
              </div>
            </div>
            <div className="flex flex-1">
              <div
                className="flex-1 px-3 py-1"
                style={{
                  backgroundColor: "#E2F4F8",
                }}
              >
                <p
                  className="text-md font-normal capitalize"
                  style={{ color: "#75879B" }}
                >
                  Mobile No. :
                </p>
                <p className="text-lg font-medium capitalize">
                  {storeData.mobileNo}
                </p>
              </div>

              <div
                className="flex-1 px-3 py-1"
                style={{
                  backgroundColor: "#F8FFEE",
                }}
              >
                <p
                  className="text-md font-normal capitalize"
                  style={{ color: "#75879B" }}
                >
                  Address :
                </p>
                <p className="text-lg font-medium capitalize">
                {storeData?.address?.fullAddress}
                </p>
              </div>
              <div
                className="flex-1 px-3 py-1"
                style={{
                  backgroundColor: "#E2F4F8",
                }}
              ></div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div className="flex-1">
          <div
            className="flex-1  surface-0"
            style={{ "--surface-0": "#EAEFF5" }}
          >
            <div className="flex justify-content-between mx-4">
              <div className="py-1">
                <p className=" text-2xl  font-bold ">
                  Registration Info
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="flex-1 ">
          <div className="m-4 shadow-4">
            <div className="flex flex-1">
              <div
                className="flex-1 px-3 py-1"
                style={{
                  backgroundColor: "#F8FFEE",
                }}
              >
                <p
                  className="text-md font-normal capitalize"
                  style={{ color: "#75879B" }}
                >
                  Invoice Gen Name :
                </p>
                <p className="text-lg font-medium capitalize">
                  {" "}
                  {storeData.storeInvoiceGenName}
                </p>
              </div>
              <div
                className="flex-1 px-3 py-1"
                style={{
                  backgroundColor: "#E2F4F8",
                }}
              >
                <p
                  className="text-md font-normal capitalize"
                  style={{ color: "#75879B" }}
                >
                  Invoice Gen No :
                </p>
                <p className="text-lg font-medium capitalize">
                  {storeData.storeInvoiceGenNo}
                </p>
              </div>
              <div
                className="flex-1 px-3 py-1"
                style={{
                  backgroundColor: "#F8FFEE",
                }}
              >
                <p
                  className="text-md font-normal capitalize"
                  style={{ color: "#75879B" }}
                >
                  Brand Name :
                </p>
                <p className="text-lg font-medium capitalize">
                  {brandProfileData.name}
                </p>
              </div>
             
              <div
                className="flex-1 px-3 py-1"
                style={{
                  backgroundColor: "#E2F4F8",
                }}
              >
                <p
                  className="text-md font-normal capitalize"
                  style={{ color: "#75879B" }}
                >
                  Registration Date :
                </p>
                <p className="text-lg font-medium capitalize">
                  {formattedRegistrationDate}
                </p>
              </div>

               
            </div>
          </div>
        </div>
      </div>
      <div>
        <div className="flex-1">
          <div
            className="flex-1  surface-0"
            style={{ "--surface-0": "#EAEFF5" }}
          >
            <div className="flex justify-content-between mx-4">
              <div className="py-1">
                <p className=" text-2xl  font-bold ">
                  Other Info
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="flex-1 ">
          <div className="m-4 shadow-4">
            
            <div className="flex flex-1">
               

              <div
                className="flex-1 px-3 py-1"
                style={{
                  backgroundColor: "#F8FFEE",
                }}
              >
                <p
                  className="text-md font-normal capitalize"
                  style={{ color: "#75879B" }}
                >
                  Account Status :
                </p>
                {storeData.status === "ACTIVE" ? (
                  <div className="flex ">
                    <p className="text-lg font-medium capitalize mr-2">
                      Active{" "}
                    </p>
                    <img
                      src={
                        "Laundy_App_Icons_Gifs/Order_Statuses_icons/Paid_Payment_Status.png"
                      }
                      style={{
                        height: 22,
                        width: 22,
                      }}
                    />
                  </div>
                ) : (
                  <div className="flex ">
                    <p className="text-lg font-medium capitalize mr-2">
                      DeActive{" "}
                    </p>
                    <img
                      src={
                        "Laundy_App_Icons_Gifs/Order_Statuses_icons/Unpaid_Payment_Status.png"
                      }
                      style={{
                        height: 22,
                        width: 22,
                      }}
                    />
                  </div>
                )}
              </div>
              <div
                className="flex-1 px-3 py-1"
                style={{
                  backgroundColor: "#E2F4F8",
                }}
              >
                <p
                  className="text-md font-normal capitalize"
                  style={{ color: "#75879B" }}
                >
                  Offer Price Access :
                </p>
                {storeData.offerPriceEnabled === true ? (
                  <div className="flex ">
                    
                    <img
                      src={
                        "Laundy_App_Icons_Gifs/Order_Statuses_icons/Paid_Payment_Status.png"
                      }
                      style={{
                        height: 22,
                        width: 22,
                      }}
                    />
                  </div>
                ) : (
                  <div className="flex ">
                    
                    <img
                      src={
                        "Laundy_App_Icons_Gifs/Order_Statuses_icons/Unpaid_Payment_Status.png"
                      }
                      style={{
                        height: 22,
                        width: 22,
                      }}
                    />
                  </div>
                )}
              </div>
              
            </div>
          </div>
        </div>
      </div>
      <StoreMenu setVisible={setVisible} visible={visible} />
      <ButtonLink />
    </div>
  );
};

export default StoreProfile;
